import React from 'react';
import { Scrollbar } from '../../UI';

const FormRootLayout = ({
	form,
	button,
	noScrollLayout,
	stylesHeight,
	stylesInScroll
}) => (
	<div style={{
		marginTop: '1em',
		height: 'calc(100% - 90px)',
	}}
	>
		<div style={{
			height: '90%',
			overflow: 'hidden',
			...stylesHeight
		}}
		>
			{noScrollLayout ?
				<div style={{ paddingRight: '1em', height: '100%' }}>
					{form}
				</div>
				:
				<Scrollbar>
					<div style={{ paddingRight: '1em', ...stylesInScroll }}>
						{form}
					</div>
				</Scrollbar>
			}
		</div>
		{button &&
			<div style={{
				height: '10%',
				paddingTop: '.5em',
				display: 'flex',
				alignItems: 'end',
				justifyContent: 'flex-end'
			}}
			>
				{button}
			</div>
		}
	</div>
);

export default FormRootLayout;
